import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, Output } from '@angular/core';

// Supposed to be used with bfa-accordion only. Should not be used standalone
@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'accordion-panel',
	templateUrl: './accordion-panel.component.html',
	styleUrls: ['./accordion-panel.component.scss'],
	animations: [
		trigger('slideInOut', [
			transition(':enter', [style({ transform: 'translateY(-100%)', opacity: 0 }), animate('400ms ease-in-out', style({ transform: 'translateY(0%)', opacity: 1 }))]),
			transition(':leave', [animate('400ms ease-in-out', style({ transform: 'translateY(-100%)', opacity: 0 }))])
		])
	]
})
export class AccordionPanelComponent {
	@Input() public isCollapsed: boolean = true;
	@Output() public onToggleChange: EventEmitter<any> = new EventEmitter<any>();

	public togglePanel(event: Event): void {
		event.preventDefault();
		const target = event.target as HTMLElement;
		const attribute = target.parentElement && (
			target.parentElement.getAttribute('type') || (target.parentElement.parentElement && target.parentElement.parentElement.getAttribute('type'))
		);
		if (attribute !== 'info-circle') {
			this.onToggleChange.emit();
		}
	}
}
